// Types for the application

// Enum for the user types used in the chat/chat history
export enum UserType {
  AI = 'AI',
  HUMAN = 'Human',
  SOURCE = 'Source',
}

// Enum for the various page views for the left navbar
export enum PAGE_VIEW {
  LANDING = 'landing',
  HUB = 'hub',
  CHAT = 'chat',
  HISTORY = 'history',
  SETTINGS = 'settings',
  HELP = 'help',
  UPLOAD = 'upload',
  TRANSCRIPT = 'uploadTranscript',
}

// Enum for the two tab views on the chat page
export enum CHAT_TAB_VIEWS {
  RESPONSE_DETAILS = 'response-details',
  STORYBUILDER = 'storybuilder',
}

// Enum for the two current type of API function calls
export enum FunctionType {
  CHAT = 'chat',
  REPORT = 'generate_report',
  SAVEUSERDEATILS = 'save_user_details',
  FETCHUSERDETAILS = 'fetch_user_details',
  SESSION = 'generate_sessionuid',
  PROMPTFEEDBACK = 'save_prompt_feedback',
  EXPORTHISTORY = 'export_history',
  FETCHPROJECTDETAILS = 'fetch_project_details',
  // FETCHPROJECTNAMES = 'get_project',
  FETCHCHATHISTORY = 'fetch_chat_history',
  UPDATECHATHISTORY = 'update_chat_history',
  DELETECHATHISTORY = 'delete_chat_history',
  FETCHHISTORYFROMBLOB = 'fetch_history_from_blob',
  DOWNLOADCHATHISTORY = 'download_chat_history',
  FETCHSUPPORTSERVICENOW = 'fetch_supportservicenow',
  FETCHSUPPORTSERVICENOW_RITM = 'fetch_supportservicenow_ritm',
  FETCHSURVEYMASTER = 'fetch_survey_master',
  SAVESURVEYMASTER = 'save_surveytracking',
  CANCELRESPONSE = 'chat_terminate',
  FETCHACCOUNTNAMES = 'get_account',
  FETCHINDUSTRYNAMES = 'get_contact_industry',
  CREATENEWPROJECT = 'new_project',
  GETPROJECT = 'get_project',
  GETCOUNTRY = 'get_country',
  GETVENUE = 'get_venue',
  GETPRODUCT = 'get_product',
  CREATENEWINTERVIEW = 'new_interview',
  SAVEUPLOADEDFILEDETAILS = 'upload',
  GETUPLOADEDFILEDETAILS = 'get_file_status',
  DOWNLOADTEMPLATE = 'get_template_file',
  SEARCH = 'search',
}

//Enum for events
export enum ClassNameEvent {
  ADD,
  REMOVE,
}

// Object representing a transcript source received from the API and displayed in the Response Details tab
export interface Source {
  interviewId: string;
  citation: string;
  transcript: string;
  score: number;
  interview_date?: string;
  source?: string;
  id?: string;
}

// Object representing a transcript source received from the API and displayed in the Response Details tab
export interface DetailSource {
  showCitation: boolean;
  sourceList: Source[];
}

// Object representing a chat response received from the API and displayed in the chat window
export interface Response {
  responseId: string;
  genArcPromptAnalyticsUId: string;
  market: string;
  response: string;
}
// Object representing a chat response with source received from the API and displayed in the story builder
export interface ResponseWithSource extends Response {
  source: string;
  projectName: string[];
}

// Shared object used in the various chat utility functions
export interface ChatbotResources {
  createChatBotMessage: any;
  createClientMessage: any;
  setState: any;
  resetApp: boolean;
  setResetApp: any;
  setResponseDetailsSources: any;
  sourceHistory: { [key: string]: Source[] };
  setSourceHistory: (sourceHistory: any) => void;
  searchBatchesHistory?: { [key: string]: any };
  setSearchBatchesHistory?: (searchBatchesHistory: any) => void;
  setStoryResponses: (storyResponses: Response[]) => void;
  chatHistory: string;
  setChatHistory: (history: string) => void;
  setActiveChatTab: (tab: CHAT_TAB_VIEWS) => void;
  userMessage: React.MutableRefObject<string>;
  selectedResponseId: number | null;
  setSelectedResponseId: any;
  websocket: signalR.HubConnection | null;
  chatResponse: string;
  setExportStoryInProgress: (flag: boolean) => void;
  setGenArcHistoryPrompts: (promptHistory: any) => void;
  setDownloadChatHistory: (history: string) => void;
  setChatPromptResponseHistory: (history: ChatHistory[]) => void;
  selectedProject: string[] | null;
  selectedTranscript: string | null;
  chatWindowConversations: any;
  setChatWindowConversations: (messages: any) => void;
  setChatResponse: (response: any) => void;
  isChatHistoryActive: boolean;
  setIsChatHistoryActive: (flag: boolean) => void;
  prompt: string;
  setPrompt: (prompt: string) => void;
  instanceId: string;
  setInstanceId: (instanceId: string) => void;
  currentGenArcPromptAnalyticsUId: string;
  setCurrentGenArcPromptAnalyticsUId: (Uid: string) => void;
  isPromptCancelling: false;
  setIsPromptCancelling: (flag: boolean) => undefined;
  promptCancellationStatus: STATUS;
  setPromptCancellationStatus: (status: STATUS) => void;
}

//Object representing a chat history to be stored
export interface ChatHistory {
  title: string;
  response: string;
  source: string;
  SelectedProjects: string[] | null;
}
//Enum to represent list of sources
export enum SourceType {
  GENAI = 'Generate Insights powered by GenAI on the Console',
  OPENAI = 'Azure OpenAI',
  CORE = 'CORE',
}

//Object representing each item inside accordion of chat history panel
export interface ChatHistoryItem {
  ConfigurationName: string | null;
  blobURL: string;
  displayName: string;
  fileName: string;
  genArcPromptAnalyticsUID: string;
  promptName: string;
}

//Object representing AccordionItems of chat history panel
export interface ChatHistoryItems {
  title: string;
  chatHistoryItems: ChatHistoryItem[] | null;
}

export interface UpdatingChatHistoryState {
  state: boolean;
  action: string;
}

export interface ClientData {
  Name: string;
  Id: string;
  Market: string;
  MarketUnit: string;
  IndustrySegment: string;
  Demoflag: string;
  DominantIndustryTxt: string;
}

export enum STATUS {
  SUCCESS = 'success',
  FAILED = 'failed',
  PENDING = 'pending',
  DEFAULT = 'no_status',
}

export interface UploadDocuments {
  openUploadModal: boolean;
  setOpenUploadModal: any;
  setIsUploading: any;
}
